import widget from './previewWidget.json';
async function getWidgetPreview () {
    this.widget = await this.injectDefaults(widget);
    return this.widget;
}

export default getWidgetPreview;
